<div
  #mapContainerElement
  [style.visibility]="!hideMap() ? 'visible' : 'hidden'"
  class="relative w-screen left-0 z-1 top-0"
  id="map-container"
>
  <div class="z-4 fixed left-4 bottom-4 flex flex-col gap-2">
    <button
      (click)="goToEventPosition()"
      class="bg-white/40 backdrop-blur-md cursor-pointer w-10 h-10 p-2 shadow-lg hover:bg-neutral-200 rounded-sm"
    >
      <i-lucide [name]="PartyPopper" color="#000"></i-lucide>
    </button>
    @if (isUserPositionKnown()) {
      <button
        class="bg-white/40 backdrop-blur-md cursor-pointer w-10 h-10 p-2 shadow-lg hover:bg-neutral-200 rounded-sm"
        (click)="goToUserPosition()"
      >
        <i-lucide color="#000" [name]="LocateFixed"></i-lucide>
      </button>
    }
  </div>
  <div
    #mapElement
    class="fixed h-screen w-screen top-0 left-0"
    id="map"
  ></div>
</div>
<div
  [style.display]="!hideMap() ? 'none' : null"
  class="p-4 text-center text-gray-500"
>
  Keine Orte vorhanden.
</div>
